import { Button } from '@/components/ui/button';
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/components/ui/select';

interface PaginationControlsProps {
	currentPage: number;
	totalPages: number;
	pageSize: number;
	totalItems: number;
	displayedItems: number;
	onPageChange: (page: number) => void;
	onPageSizeChange: (pageSize: number) => void;
	pageSizeOptions?: number[];
	itemName?: string; // e.g., "traces", "evaluations"
}

export const PaginationControls = ({
	currentPage,
	totalPages,
	pageSize,
	totalItems,
	displayedItems,
	onPageChange,
	onPageSizeChange,
	pageSizeOptions = [5, 10, 20, 50],
	itemName = 'items',
}: PaginationControlsProps) => {
	const handlePreviousPage = () => {
		onPageChange(Math.max(0, currentPage - 1));
	};

	const handleNextPage = () => {
		onPageChange(Math.min(totalPages - 1, currentPage + 1));
	};

	const handlePageSizeChange = (value: string) => {
		onPageSizeChange(Number(value));
		onPageChange(0); // Reset to first page when changing page size
	};

	return (
		<div className='tw-flex tw-items-center tw-justify-between'>
			<div className='tw-flex-1 tw-text-sm tw-text-muted-foreground'>
				Showing {displayedItems} of {totalItems} {itemName}
			</div>
			<div className='tw-flex tw-items-center tw-gap-4'>
				<Select value={`${pageSize}`} onValueChange={handlePageSizeChange}>
					<SelectTrigger className='tw-h-8'>
						<SelectValue placeholder={pageSize} />
					</SelectTrigger>
					<SelectContent side='top'>
						{pageSizeOptions.map((size) => (
							<SelectItem key={size} value={`${size}`}>
								{size}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
				<div className='tw-flex tw-items-center tw-gap-4'>
					<Button
						variant='outline'
						size='sm'
						onClick={handlePreviousPage}
						disabled={currentPage === 0}
					>
						Previous
					</Button>
					<div className='tw-text-sm tw-h-8 tw-min-w-[80px] tw-flex tw-items-center tw-justify-center tw-whitespace-nowrap'>
						Page {currentPage + 1} of {Math.max(1, totalPages)}
					</div>
					<Button
						variant='outline'
						size='sm'
						onClick={handleNextPage}
						disabled={currentPage >= totalPages - 1}
					>
						Next
					</Button>
				</div>
			</div>
		</div>
	);
};
